  const items = [
    {
      id: 1,
      image: "http://poke-meta.com/static/images/items/bangle.png",
    },
    {
      id: 2,
      image: "http://poke-meta.com/static/images/items/barrier.png",
    }
    ,
    {
      id: 3,
      image: "http://poke-meta.com/static/images/items/chargingcharm.png",
    }
    ,
    {
      id: 4,
      image: "http://poke-meta.com/static/images/items/choicescarf.png",
    }
    ,
    {
      id: 5,
      image: "http://poke-meta.com/static/images/items/claw.png",
    }
    ,
    {
      id: 6,
      image: "http://poke-meta.com/static/images/items/cloak.png",
    }
    ,
    {
      id: 7,
      image: "http://poke-meta.com/static/images/items/coin.png",
    }
    ,
    {
      id: 8,
      image: "http://poke-meta.com/static/images/items/drain.png",
    }
    ,
    {
      id: 9,
      image: "http://poke-meta.com/static/images/items/egg.png",
    }
    ,
    {
      id: 10,
      image: "http://poke-meta.com/static/images/items/focus.png",
    }
    ,
    {
      id: 11,
      image: "http://poke-meta.com/static/images/items/glasses.png",
    }
    ,
    {
      id: 12,
      image: "http://poke-meta.com/static/images/items/incense.png",
    }
    ,
    {
      id: 13,
      image: "http://poke-meta.com/static/images/items/king.png",
    }
    ,
    {
      id: 14,
      image: "http://poke-meta.com/static/images/items/leftover.png",
    }
    ,
    {
      id: 15,
      image: "http://poke-meta.com/static/images/items/muscle.png",
    }
    ,
    {
      id: 16,
      image: "http://poke-meta.com/static/images/items/rapidfire.png",
    }
    ,
    {
      id: 17,
      image: "http://poke-meta.com/static/images/items/rescue.png",
    }
    ,
    {
      id: 18,
      image: "http://poke-meta.com/static/images/items/rocky.png",
    }
    ,
    {
      id: 19,
      image: "http://poke-meta.com/static/images/items/smoke.png",
    }
    ,
    {
      id: 20,
      image: "http://poke-meta.com/static/images/items/specs.png",
    }
    ,
    {
      id: 21,
      image: "http://poke-meta.com/static/images/items/spoon.png",
    }
    ,
    {
      id: 22,
      image: "http://poke-meta.com/static/images/items/vest.png",
    }
    ,
    {
      id: 23,
      image: "http://poke-meta.com/static/images/items/weakness.png",
    },
    {
      id: 24,
      image: "http://poke-meta.com/static/images/items/tm.png",
    }
  ];

export default items;
